var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e4f41a94624612d33ca11793aa87636f.js').default;export default
        Object.assign({}, scope_0 )
    